import { Navigate } from "react-router";
import { useAuthStore } from "@/store/useAuthStore";
import { getDefaultRoute } from "@/utils/getDefaultRoute";

/**
 * Smart redirect component that navigates users to their first accessible dashboard
 * based on their permissions
 */
export function DefaultRedirect() {
  const { user } = useAuthStore();
  const defaultRoute = getDefaultRoute(user?.permissionNames || []);

  return <Navigate to={defaultRoute} replace />;
}
